import {
  GET_TRADES,
  TRADES_LOADING,
  TRADES_LOADING_FINISHED,
  REPORTS_LOADING,
  REPORTS_LOADING_FINISHED,
  RESET_LOADING,
  FINISH_LOADING
} from "../actions/types";

const initialState = {
  trades: null,
  loading: false,
  loadinFinished:false,
  loading_reports: false
};

export default function tradeReducer(state = initialState, action) {
  switch (action.type) {
    case TRADES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case TRADES_LOADING_FINISHED:
      return {
        ...state,
        loading: false,
      };
    case GET_TRADES:
      return {
        ...state,
        trades: action.payload,
        loading: false,
      };
    case REPORTS_LOADING:
      return {
      ...state,
      loading_reports: true,
    };
    case REPORTS_LOADING_FINISHED:
            alert("reset ese")
      return {
      ...state,
      loading_reports: false,
    };
    case FINISH_LOADING:
      return {
        ...state,
        loadinFinished: true,
      };
    case RESET_LOADING:
       return {
      ...state,
      loadinFinished: false,
    };
    default:
      return state;
  }
}
